/* Shopify owns cart contents, inventory, discounts and totals. No automatic mutation retries. */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer?.showModal) return;
  const root = drawer.dataset.root, section = drawer.dataset.sectionId;
  const content = drawer.querySelector('[data-cart-drawer-content]');
  const status = drawer.querySelector('[data-cart-status]');
  const recovery = drawer.querySelector('[data-cart-recovery]');
  let busy = false, opener, readVersion = 0, disabled = [];
  function lock(value) {
    busy = value; drawer.setAttribute('aria-busy', String(value));
    if (value) {
      disabled = [...document.querySelectorAll('[data-purchase-button]:not(:disabled),[data-cart-drawer] button:not(:disabled):not([data-cart-close]),[data-cart-drawer] input:not(:disabled)')];
      disabled.forEach(node => { node.disabled = true; });
    } else { disabled.forEach(node => { if (node.isConnected) node.disabled = false; }); disabled = []; }
  }
  function open(trigger) {
    if (drawer.open) return;
    opener = trigger; drawer.showModal(); document.documentElement.classList.add('cart-drawer-open');
    drawer.querySelector('[data-cart-close]').focus({ preventScroll:true });
  }
  function close() { drawer.close(); }
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('cart-drawer-open');
    if (opener?.isConnected) opener.focus({ preventScroll:true });
  });
  function render(html) {
    if (typeof html !== 'string') throw new Error('Cart preview unavailable.');
    const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    if (!replacement) throw new Error('Cart preview unavailable.');
    content.replaceChildren(...replacement.childNodes); content.dataset.count = replacement.dataset.count;
    const count = Number(replacement.dataset.count) || 0;
    drawer.querySelector('[data-drawer-count]').textContent = String(count);
    document.querySelectorAll('.header-cart').forEach(link => {
      link.setAttribute('aria-label', count ? `Cart, ${count} ${count === 1 ? 'item' : 'items'}` : 'Cart');
      let badge = link.querySelector('.cart-count');
      if (!count) { badge?.remove(); return; }
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; badge.setAttribute('aria-hidden','true'); link.append(badge); }
      badge.textContent = String(count);
    });
    document.dispatchEvent(new CustomEvent('piranha:cart-updated', {detail:{count}}));
  }
  async function refresh() {
    const url = new URL(root, location.origin); url.searchParams.set('sections', section);
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Could not refresh your cart.');
    const data = await response.json(); return data[section];
  }
  async function view(trigger) {
    open(trigger); if (busy) return;
    const version = ++readVersion; status.textContent = 'Loading your cart…'; recovery.hidden = true;
    try { const html = await refresh(); if (version !== readVersion || busy) return; render(html); status.textContent = ''; }
    catch { if (version === readVersion) { status.textContent = 'The cart preview could not load. Open your full cart to continue.'; recovery.hidden = false; } }
  }
  async function change(path, body, message, focusKey) {
    if (busy) return;
    ++readVersion; lock(true); status.textContent = 'Updating your cart…'; recovery.hidden = true;
    const form = body instanceof FormData;
    if (form) { body.set('sections', section); body.set('sections_url', root); body.delete('return_to'); }
    else body = {...body,sections:section,sections_url:root};
    let accepted = false;
    try {
      const response = await fetch(`${root}cart/${path}.js`, {method:'POST',credentials:'same-origin',headers:form ? {} : {'Content-Type':'application/json'},body:form ? body : JSON.stringify(body),signal:AbortSignal.timeout(20000)});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not update this item.');
      accepted = true;
      render(data.sections?.[section] || await refresh());
      status.textContent = message;
      if (drawer.open && focusKey) {
        const input = [...content.querySelectorAll('[data-cart-key]')].find(row => row.dataset.cartKey === focusKey)?.querySelector('input');
        (input || drawer.querySelector('[data-cart-close]')).focus({preventScroll:true});
      }
    } catch (error) {
      status.textContent = accepted ? 'Your cart was updated, but the preview could not refresh. View your cart to continue.' : ['TimeoutError','TypeError','SyntaxError','AbortError'].includes(error.name) ? 'We could not confirm the update. Check your cart before adding again.' : error.message;
      recovery.hidden = false;
    } finally { lock(false); }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('.header-cart');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) { event.preventDefault(); view(link); }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('.product-form') || event.submitter && !event.submitter.matches('[data-cart-add]')) return;
    event.preventDefault(); if (busy) return;
    const trigger = event.submitter || event.target.querySelector('[data-cart-add]');
    const body = new FormData(event.target); open(trigger); change('add', body, 'Added to your cart.');
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    const remove = event.target.closest('.cart-remove');
    if (remove) { event.preventDefault(); if (!busy) change('change', {id:remove.closest('[data-cart-key]').dataset.cartKey,quantity:0}, 'Item removed from your cart.', remove.closest('[data-cart-key]').dataset.cartKey); }
  });
  drawer.addEventListener('change', event => {
    const input = event.target.closest('input[name="updates[]"]'); if (!input || busy) return;
    if (!input.reportValidity()) return;
    const quantity = Number(input.value); if (!Number.isSafeInteger(quantity) || quantity < 0) return;
    const key = input.closest('[data-cart-key]').dataset.cartKey;
    change('change', {id:key,quantity}, 'Cart updated.', key);
  });
  drawer.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('input[name="updates[]"]')) { event.preventDefault(); event.target.dispatchEvent(new Event('change',{bubbles:true})); }
  });
  drawer.addEventListener('submit', event => { if (busy) event.preventDefault(); });
  let backdrop = false;
  const outside = event => { const r=drawer.getBoundingClientRect(); return event.target===drawer && (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom); };
  drawer.addEventListener('pointerdown', event => { backdrop=outside(event); });
  drawer.addEventListener('pointercancel', () => { backdrop=false; });
  drawer.addEventListener('click', event => { if (backdrop && outside(event)) close(); backdrop=false; });
})();
